import { eventsController } from '../classes/eventsConroller';
import { Marquee } from '../vendor/marquee';

eventsController.load(() => {
    const marquees = document.querySelectorAll('.marquee');
    if (!marquees.length) {
        return;
    }

    marquees.forEach(marquee => {
        new Marquee(marquee);
    });
});